"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = exports.getFullName = exports.stringAvatar = exports.stringToColor = void 0;
const themeUtils_1 = require("themes/themeUtils");
const stringToColor = (string) => {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
};
exports.stringToColor = stringToColor;
const stringAvatar = (name) => {
    const nameParts = name.split(' ');
    return {
        sx: {
            bgcolor: (0, themeUtils_1.applyOpacityToHex)((0, exports.stringToColor)(name), 0.6),
            width: 28,
            height: 28,
            fontSize: 12,
            marginLeft: '16px',
            color: 'text.primary',
            fontWeight: 500,
            textTransform: 'uppercase',
        },
        children: nameParts.length > 1
            ? `${nameParts[0][0]}${nameParts[1][0]}`
            : `${nameParts[0][0]}`,
    };
};
exports.stringAvatar = stringAvatar;
const getFullName = (userProfile) => {
    if (!userProfile) {
        return '';
    }
    let fullName = '';
    if (userProfile.firstName && userProfile.lastName) {
        fullName = `${userProfile.firstName} ${userProfile.lastName}`;
    }
    else if (userProfile.primaryAddress && userProfile.primaryAddress.fullName) {
        fullName = userProfile.primaryAddress.fullName;
    }
    return fullName;
};
exports.getFullName = getFullName;
const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
exports.isEmail = isEmail;
